import { Box, Collapse, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import TopicSelectionCard from "./TopicSelectionCard";
import { useAppDispatch, useAppSelecter } from "../../hooks/storeHooks";
import {
  fetchAllClusters,
  fetchAllExams,
  fetchAllGoals,
  fetchAllSections,
  fetchAllSubtopics,
  fetchALLTopics,
} from "../../store/slices/contentFeedback/contentFeedbackSlice";
import { getServerEnvironment } from "../../store/slices/constants/staticContents";
import { RootState } from "../../store/store";
import SubtopicCard from "./SubtopicCard";
import GlobalLoader from "../../Components/GlobalLoader";
import SingleClusterCard from "./SingleClusterCard";
import CustomIconButton from "../../Components/CustomIconButton";
import { expand } from "../../assets/svgs";
import globalColors from "../../globalColors";
import { fetchTagsData } from "../../store/slices/exams/thunks/fetchContentData";
const expandButtonCss = {
  background: globalColors.primary.pureWhite,
  position: "absolute",
  bottom: "40px",
  borderTop: "1px solid #C8C8C8",
  borderBottom: "1px solid #C8C8C8",
  borderRadius: "0 15px 15px 0",
  borderRight: "1px solid #C8C8C8",
  writingMode: "vertical-rl",
  boxShadow: "4px 0px 6px 0px #00000040",
  padding: "10px 3px 10px",
  minHeight: "90px",
};
function QuestionClusterMapping() {
  const dispatch = useAppDispatch();
  const dFilter = {
    exam: "",
    exam_id: "",
    goal: "",
    goal_id: "",
    section: "",
    section_id: "",
    topic: "",
    topic_id: "",
    subtopic: "",
    subtopic_id: "",
    cluster: "",
    cluster_id: "",
    cluster_color: "",
  };
  const localFilters = {
    subtopic: "all",
    topic: "all",
    cluster: "all",
  };

  const localFiltersValues = localStorage.getItem(
    btoa(`mapping-review-filters-${getServerEnvironment()}`)
  );
  const [filters, setFilters] = useState(
    localFiltersValues && localFiltersValues !== undefined
      ? JSON.parse(atob(localFiltersValues))
      : dFilter
  );
  const [localFilterState, setLocalFilterState] = useState(
    localStorage.getItem(
      btoa(`mapping-local-filters-${getServerEnvironment()}`)
    )
      ? JSON.parse(
          atob(
            localStorage.getItem(
              btoa(`mapping-local-filters-${getServerEnvironment()}`)
            ) || ""
          )
        )
      : localFilters
  );
  const { subtopicFilter, topicFilter, clusterFilter } = localFilterState;
  const [loadingScreen, setLoading] = useState(false);
  const [expandTopicCard, setTopicCard] = useState(true);
  const { masters, loading } = useAppSelecter(
    (state: RootState) => state.contentFeedback
  );
  const { queLoading } = useAppSelecter(
    (state: RootState) => state.QuestionReview
  );
  useEffect(() => {
    dispatch(fetchAllExams());
    dispatch(fetchTagsData());
  }, []);

  useEffect(() => {
    if (masters.exams && masters.exams.length === 1) {
      if (filters.exam !== masters.exams[0].name) {
        setFilters((prev: any) => ({
          ...prev,
          exam: masters.exams[0].name,
          exam_id: masters.exams[0].id,
        }));
      }
    }
  }, [dispatch, masters.exams]);
  useEffect(() => {
    if (filters.exam_id) {
      dispatch(fetchAllGoals(filters.exam_id));
    }
  }, [dispatch, filters.exam_id]);

  useEffect(() => {
    if (filters.goal_id) {
      dispatch(fetchAllSections(filters.goal_id ? filters.goal_id : ""));
    }
  }, [dispatch, filters.goal_id]);

  useEffect(() => {
    dispatch(fetchALLTopics(filters.section_id ? filters.section_id : ""));
  }, [dispatch, filters.section_id]);

  useEffect(() => {
    dispatch(fetchAllSubtopics(filters.topic_id ? filters.topic_id : ""));
  }, [dispatch, filters.topic_id]);

  useEffect(() => {
    dispatch(fetchAllClusters(filters.subtopic_id ? filters.subtopic_id : ""));
  }, [dispatch, filters.subtopic_id]);
  useEffect(() => {
    localStorage.setItem(
      btoa(`mapping-review-filters-${getServerEnvironment()}`),
      btoa(JSON.stringify(filters))
    );
  }, [filters]);

  return (
    <Stack
      width={"calc(100% - 16px)"}
      height={"calc(100% - 4px)"}
      margin="0 8px 4px"
      sx={{
        "& img": { maxWidth: "100%" },
      }}
    >
      {(loadingScreen ? loadingScreen : loading || queLoading) && (
        <GlobalLoader open={true} />
      )}
      <Stack direction={"row"} width={"100%"} height={"100%"}>
        <Collapse
          orientation="horizontal"
          in={expandTopicCard}
          timeout={1000}
          sx={{
            maxWidth: "40%",
            "& .MuiCollapse-wrapperInner": {
              maxWidth: "100%",
            },
          }}
        >
          <Stack
            height={"100%"}
            sx={{
              width: "316px",
              borderRadius: "8px",
              maxWidth: "100%",
            }}
          >
            <Stack sx={{ height: "100%", width: "100%", overflow: "hidden" }}>
              <TopicSelectionCard
                setFilters={setFilters}
                filters={filters}
                localFilterState={localFilterState}
                setLocalFilterState={(data: any) => {
                  localStorage.setItem(
                    btoa(`mapping-local-filters-${getServerEnvironment()}`),
                    btoa(JSON.stringify(data))
                  );
                  setLocalFilterState(data);
                }}
              />
              <SubtopicCard
                setFilters={setFilters}
                filters={filters}
                localFilterState={localFilterState}
              />
            </Stack>
          </Stack>
        </Collapse>
        <Box
          sx={{
            position: "relative",
            minHeight: "100%",
            width: "0",
            margin: "0 8px 0 0",
          }}
        >
          <CustomIconButton
            onClick={() => {
              setTopicCard(!expandTopicCard);
            }}
            sx={{
              ...expandButtonCss,
              left: "0",
            }}
            icon={expandTopicCard ? "Hide" : "Expand"}
            content={expand}
          />
        </Box>
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            flex: 8,
          }}
          height={"100%"}
        >
          <SingleClusterCard
            filters={filters}
            setFilters={setFilters}
            loadingScreen={loadingScreen}
            setLoading={setLoading}localFilterState={localFilterState}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}

export default QuestionClusterMapping;
